import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrComponentService, CtwrComponentCategoryService, CtwrItemService } from '../../../ctwr.service';

@Component({
  selector: 'app-component',
  templateUrl: './component.component.html',
  styleUrls: ['./component.component.scss']
})
export class ComponentComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly componentService: CtwrComponentService,
    private readonly componentCategoryService: CtwrComponentCategoryService,
    private readonly itemService: CtwrItemService
  ) {
    super();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      ItemIds: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ComponentCategoryIds: []
    })

    this.formDialog.initilize("Item Name", this.editForm, this.formDialogTabs);
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };
    this.componentCategoryService.read();
    this.itemService.read();
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
    this.editForm.get('Name').enable();
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.componentService.read('') :
      Promise.resolve(this.componentService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.componentService.read(`/id?id=${dataItem.Id}`)
      .then(x => {
        this.formDialog.next(x);
      })
    this.editForm.get('Name').disable();
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    const _path: string = isNew ? '' : (`/${dataItem.Id}`);
    return this.componentService.save(dataItem, isNew, _path, false)
  }

  delete(dataItem: any): Promise<any> {
    return this.componentService.remove("/" + dataItem.Id, false)
  }

  columns: any[] = [
    {
      field: 'Name',
      title: 'Item Name',
    },
    {
      field: 'CategoryNames',
      title: 'Categories'
    },
    {
      field: 'ItemDescriptions',
      title: 'Item Descriptions'
    },
  ]

  formControls = [
    {
      type: 'text',
      title: 'Item Name',
      name: 'Name',
      placeholder: 'Enter a Component Name',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
    },
    {
      type: "multiselect",
      title: "Category",
      name: "ComponentCategoryIds",
      textField: "Name",
      valueField: "Id",
      service: this.componentCategoryService,
      stretch: true
    },
    {
      type: "multiselect",
      title: "Item Descriptions",
      name: "ItemIds",
      textField: "Name",
      valueField: "Id",
      service: this.itemService,
      stretch: true
    }
  ];


  formDialogTabs = [
    {
      title: "Item Names",
      selected: true,
      formControls: this.formControls,
    },
  ];
}
